import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import api from "./api"
import store from "./store"
import router from "./router"
import "./assets/css/app.css"

Vue.config.productionTip = false
Vue.prototype.$api = api

new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app')
